import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { InEvidenzaRoutingModule } from './in-evidenza-routing.module';
import { InEvidenzaComponent } from './in-evidenza.component';
import { InEvidenzaPostComponent } from './in-evidenza-post/in-evidenza-post.component';

import { ScullyLibModule } from '@scullyio/ng-lib';

@NgModule({
  declarations: [
    InEvidenzaComponent, 
    InEvidenzaPostComponent
  ],
  imports: [
    CommonModule,
    InEvidenzaRoutingModule,
    ScullyLibModule
  ]
})
export class InEvidenzaModule { }
